import { get } from '../../../common/utils/objectUtils';
import {
    LoginActionTypes,
    LoginState,
    LOGIN,
    LOGIN_SUCCESS,
    LOGIN_FAILED,
    IS_LOGGED_IN,
    REGISTER_NEW_USER,
    SET_REDIRECT_URL,
    UNSET_REDIRECT_URL,
    SET_IS_REGISTERED,
    SET_IS_REGISTERED_WITH_NEWSLETTER,
    UserLoginDataResponse,
    UserData,
    SessionTypes,
} from './types';

const getUserDataFromResponse = (response: UserLoginDataResponse): UserData => {
    return {
        id: response.id || '',
        email: response.email || '',
        firstName: response.firstName || '',
        lastName: response.lastName || '',
        hashedEmail: response.hashedEmail || '',
        hashedId: response.hashedId || '',
        loginHash: response.loginHash || '',
        registeredAt: response.registeredAt || '',
        sessionType: response.sessionType || SessionTypes.unknown,
    };
};

const LoggedInReducer = (
    state: LoginState = {
        isFetching: false,
        didInvalidate: false,
        didFinishOnce: false,
        isLoggedIn: false,
        isRegistered: false,
        isRegisteredWithNewsletter: false,
        data: undefined,
        error: {},
    },
    action: LoginActionTypes
): LoginState => {
    switch (action.type) {
        case REGISTER_NEW_USER:
        case LOGIN:
        case IS_LOGGED_IN: {
            return {
                ...state,
                isFetching: true,
            };
        }
        case LOGIN_SUCCESS: {
            return {
                ...state,
                isFetching: false,
                isLoggedIn: !!get(action.payload, 'data.isLoggedIn', false),
                isRegistered: !!get(action.payload, 'data.isUserRegistered', false),
                data: getUserDataFromResponse(action.payload.data),
                didInvalidate: false,
                didFinishOnce: true,
            };
        }
        case LOGIN_FAILED: {
            return {
                ...state,
                isFetching: false,
                didFinishOnce: true,
                isLoggedIn: false,
                didInvalidate: true,
                error: get(action.payload, 'data.errors', action.payload),
            };
        }
        case SET_REDIRECT_URL: {
            return {
                ...state,
                redirectUrl: get(action.payload, 'url', ''),
            };
        }
        case UNSET_REDIRECT_URL: {
            return {
                ...state,
                redirectUrl: '',
            };
        }
        case SET_IS_REGISTERED: {
            return {
                ...state,
                isRegistered: get(action.payload, 'isRegistered', false),
            };
        }
        case SET_IS_REGISTERED_WITH_NEWSLETTER: {
            return {
                ...state,
                isRegisteredWithNewsletter: true,
            };
        }
        default: {
            return state;
        }
    }
};

export default LoggedInReducer;
